import validate from "/app/node_modules/.pnpm/nuxt@3.11.2_@opentelemetry+api@1.8.0_@unocss+reset@0.60.3_eslint@8.57.0_floating-vue@5.2.2_sa_57oimnmwxw2x45spgh24nh3h4a/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.11.2_@opentelemetry+api@1.8.0_@unocss+reset@0.60.3_eslint@8.57.0_floating-vue@5.2.2_sa_57oimnmwxw2x45spgh24nh3h4a/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}